import script from "./RoomDataMatrixTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoomDataMatrixTable.vue?vue&type=script&setup=true&lang=ts"

import "./RoomDataMatrixTable.vue?vue&type=style&index=0&id=3f80bfef&scoped=true&lang=css"

import exportComponent from "/builds/intranet/intranet/vue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f80bfef"]])

export default __exports__